import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X, AlertCircle } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const ServiceMessageBanner = () => {
  const [message, setMessage] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  console.log('🔔 ServiceMessageBanner: Component mounted/rendered');

  useEffect(() => {
    console.log('🔔 ServiceMessageBanner: useEffect triggered, fetching message');
    fetchServiceMessage();
  }, []);

  useEffect(() => {
    if (message && !dismissed) {
      setVisible(true);
      
      // Auto-hide after 15 seconds
      const timer = setTimeout(() => {
        setVisible(false);
      }, 15000);
      
      return () => clearTimeout(timer);
    }
  }, [message, dismissed]);

  const fetchServiceMessage = async () => {
    console.log('🔔 ServiceMessageBanner: Fetching service message from API...');
    try {
      const response = await axios.get(`${API_BASE}/api/service-message`);
      console.log('🔔 ServiceMessageBanner: API response:', response.data);
      
      if (response.data.message) {
        console.log('✅ ServiceMessageBanner: Message found, setting state');
        setMessage(response.data.message);
      } else {
        console.log('ℹ️ ServiceMessageBanner: No active message');
      }
    } catch (error) {
      console.error('❌ ServiceMessageBanner: Error fetching service message:', error);
    }
  };

  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
  };

  if (!message || !visible) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 animate-fade-in">
      <div className="bg-yellow-400 text-black px-4 py-3 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <AlertCircle className="h-5 w-5 flex-shrink-0 text-black" />
            <p className="text-sm font-medium">{message}</p>
          </div>
          <button
            onClick={handleDismiss}
            className="flex-shrink-0 p-1 hover:bg-yellow-500 rounded transition-colors"
            aria-label="Lukk melding"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceMessageBanner;
